import ModelWithFacilityApi from "./ModelWithFacilityApi";

export default class ControllerApi extends ModelWithFacilityApi {
	constructor(token, clientId, onUnauthorized) {
		super(token, clientId, onUnauthorized);
		this.baseUrl = this.getBaseUrl() + "controllers/";
	}

}
